import moment from 'moment';

export const getQueueGuessingRows = (data) => {
	const rows = data.map((d, i) => {
		const [currentFriday, nextFriday] = d.results.sort(
			(a, b) => a.days_since_current_monday - b.days_since_current_monday,
		);

		return (
			<tr key={i}>
				<td>{i + 1}.</td>
				<td>{moment(d.created_at).format('YYYY-MM-DD HH:mm')}</td>
				<td>{d.queue.name}</td>
				<td>{d.t2_fresh || '----'}</td>
				<td>{currentFriday.min_element_in_target}</td>
				<td>{currentFriday.target_dequeue_count}</td>
				<td>{currentFriday.result}</td>
				<td>{nextFriday.result}</td>
			</tr>
		);
	});

	return rows;
};
